import { BlankSlate, Box, Button } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useCompetencyGroupsDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import { CompetencyGroupItemActions } from './CompetencyGroupItemActions'

interface Props {
  onNewCompetencyGroup: () => void
}
export const CompetencyGroupsDataTable = ({ onNewCompetencyGroup }: Props) => {
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()

  const source = useCompetencyGroupsDataTable(
    [
      {
        identifier: 'name',
        kind: ProjectionKind.Path,
        title: i18n.t('competencies_v3.competency_groups_table.columns.name'),
        path: 'name',
      },
      {
        identifier: 'actions',
        kind: ProjectionKind.Decorative,
        render: (competencyGroup) => <CompetencyGroupItemActions item={competencyGroup} />,
        width: 112,
      },
    ],
    {
      variables: { search: debouncedSearch },
    }
  )

  return (
    <>
      <DataTable
        actions={
          <Button onClick={() => onNewCompetencyGroup()} iconName="add">
            {i18n.t('competencies_v3.competency_groups_table.new_group')}
          </Button>
        }
        source={source}
        disableDefaultActions
        emptyState={
          debouncedSearch.length > 0 ? (
            <BlankSlate
              illustration="window-user"
              title={i18n.t('competencies_v3.competency_groups_table.no_results.title')}
              description={i18n.t('competencies_v3.competency_groups_table.no_results.description')}
            />
          ) : (
            <BlankSlate
              illustration="window-user"
              title={i18n.t('competencies_v3.competency_groups_table.empty_state.title')}
              description={i18n.t(
                'competencies_v3.competency_groups_table.empty_state.description'
              )}
            >
              <Box alignItems="center">
                <Button onClick={onNewCompetencyGroup} iconName="add">
                  {i18n.t('competencies_v3.competency_groups_table.empty_state.new_button')}
                </Button>
              </Box>
            </BlankSlate>
          )
        }
        sort={{ path: 'name', direction: 'asc' }}
        search={{
          placeholder: i18n.t('common.search_by'),
          onChange: onSearch,
          value: search,
        }}
      />
    </>
  )
}
